import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    this.modalId = this.element.dataset.modalId

    // Close modal when Turbo navigates to a new page
    this.closeOnNavigate = this.close.bind(this)
    document.addEventListener('turbo:before-cache', this.closeOnNavigate)
    document.addEventListener('turbo:before-render', this.closeOnNavigate)
  }

  disconnect () {
    // Clean up event listeners when controller disconnects
    document.removeEventListener('turbo:before-cache', this.closeOnNavigate)
    document.removeEventListener('turbo:before-render', this.closeOnNavigate)
  }

  open () {
    // Show the modal container
    this.element.classList.remove('hidden')
    document.body.style.overflow = 'hidden'

    // Get the backdrop and modal content elements
    const backdrop = this.element.querySelector('[data-modal-backdrop]')
    const modalContent = this.element.querySelector('[data-modal-content]')

    // Start the animation
    requestAnimationFrame(() => {
      if (backdrop) {
        backdrop.classList.remove('opacity-0')
        backdrop.classList.add('opacity-50')
      }
      if (modalContent) {
        modalContent.classList.remove('opacity-0', 'translate-y-4')
        modalContent.classList.add('opacity-100', 'translate-y-0')
      }
    })
  }

  close () {
    // Get the backdrop and modal content elements
    const backdrop = this.element.querySelector('[data-modal-backdrop]')
    const modalContent = this.element.querySelector('[data-modal-content]')

    // Start the closing animation
    if (backdrop) {
      backdrop.classList.remove('opacity-50')
      backdrop.classList.add('opacity-0')
    }
    if (modalContent) {
      modalContent.classList.remove('opacity-100', 'translate-y-0')
      modalContent.classList.add('opacity-0', 'translate-y-4')
    }

    // Wait for animation to complete before hiding
    setTimeout(() => {
      this.element.classList.add('hidden')
      document.body.style.overflow = ''
    }, 300) // Match the transition duration
  }

  submit (event) {
    // Custom submit logic can be added here
    // For now, we'll just dispatch a custom event
    const submitEvent = new CustomEvent('modal:submit', {
      detail: { modalId: this.modalId },
      bubbles: true
    })
    this.element.dispatchEvent(submitEvent)

    // Optionally close the modal after submit
    // this.close()
  }

  // Helper method to open modal from outside
  static open (modalId) {
    const modal = document.getElementById(modalId)
    if (modal) {
      const controller = this.getControllerForElement(modal)
      if (controller) {
        controller.open()
      }
    }
  }

  // Helper method to close modal from outside
  static close (modalId) {
    const modal = document.getElementById(modalId)
    if (modal) {
      const controller = this.getControllerForElement(modal)
      if (controller) {
        controller.close()
      }
    }
  }

  static getControllerForElement (element) {
    return element._stimulus_modal_controller ||
           (element._stimulus_modal_controller = this.application.getControllerForElementAndIdentifier(element, 'modal'))
  }
}
